import PubSub from "underpub-js";

var NavStandard = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-NavStandard',
	};

	$.extend(true, this.options, options);

};

NavStandard.prototype.init = function() {

	var self = this;

};

export default NavStandard;
